import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';

import { MensagemStatusEnum } from '../../shared/enum/mensagens/mensagem-status.enum';

@Component({
  selector: 'app-status-mensagem',
  standalone: true,
  imports: [MatIcon],
  templateUrl: './status-mensagem.component.html',
  styleUrl: './status-mensagem.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class StatusMensagemComponent {
  protected readonly MensagemStatusEnum = MensagemStatusEnum;

  @Input() status?: MensagemStatusEnum | string;
}
